import { render, staticRenderFns } from "./ProjectTabs.vue?vue&type=template&id=17e9826b"
import script from "./ProjectTabs.vue?vue&type=script&lang=js"
export * from "./ProjectTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports